import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { LOGOUT } from "@/utils/logout.js";
import Swal from 'sweetalert2';
import { format_date } from "@/utils/date_formatter";

export default {
    name: 'Advanced',
    mixins: [LOGOUT],
      mounted() {
        if (!validateToken(this.$router)) {
            return;
        }

        // Explicitly clear the service_id in Vuex when mounting
        this.$store.commit('set_service_id', null);
        this.service_id = null;
        
        // Get IDs from Vuex - in Vue 3, assign to the data properties
        this.workflow_id = this.$store.getters.get_workflow_id;
        this.service_id = this.$store.getters.get_service_id;

        this.checkThankYouConfig();

        this.showLandingOptions = true;
    },
    data() {
        return {
            // Service creation data
            serviceData: {
                service_name: ''
            },
            isSubmitting: false,
            existingServices: [],
            showCreateServiceForm: true,

            showLandingOptions: false,

            // Thank you page configuration status
            has_thank_you_config: false,

            workflow_id: null,
            
            // Sub-workflow data
            workflow_name: 'Workflow Name',
            workflows: [],
            current_page: 1,
            service_id: null,
            service_name: '',
            items_per_page: 10,
            selected_sub_workflow: null,
            edited_sub_workflow: null,
            available_workflows: [],
            new_sub_workflow: {
                service_name: '',
                sub_workflow_type: 'internal',
                external_url: '',
                workflow_id: ''
            }
        }
    },
    computed: {
        project_id() {
            return this.$store.getters.get_project_id;
        },
        total_pages() {
            return Math.ceil(this.workflows.length / this.items_per_page);
        },
        paginator_sub_workflows() {
            const start = (this.current_page - 1) * this.items_per_page;
            const end = start + this.items_per_page;
            return this.workflows.slice(start, end);
        }
    },
    methods: {


        chooseCreateSubWorkflow() {
            this.showLandingOptions = false;

            this.check_existing_workflow_service();
        },

        chooseSetupCustomThankYou() {
            this.$router.push({ name: 'thank_you_builder' });
        },

        async checkThankYouConfig() {
            const token = localStorage.getItem('token');
            const base_url = API_BASE_URL;
            try {
                const response = await fetch(
                    `${base_url}/verify_api/workflow_management_api/get_thank_you_configuration/?workflow_id=${this.workflow_id}`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Token ${token}`
                        }
                    }
                );
                if (response.ok) {
                    const data = await response.json();
                    this.has_thank_you_config = !!(data.exists || data.workflow_id);
                } else {
                    this.has_thank_you_config = false;
                }
            } catch (error) {
                console.error('Failed to check thank you config:', error);
                this.has_thank_you_config = false;
            }
        },
        

        check_existing_workflow_service() {
         
            const token = localStorage.getItem('token');
            const base_url = API_BASE_URL;
            
            Swal.fire({
                text: 'Checking workflow status...',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
            
    
            $.ajax({
                method: 'GET',
                url: `${base_url}/verify_api/service_management_api/get_workflow_service/`,
                data: {
                    workflow_id: this.workflow_id
                },
                headers: {
                    Authorization: `Token ${token}`
                },
                success: (response) => {
                    Swal.close();

                    
                    if (response.status === 'success' && response.data && response.data.service_id) {
                        this.service_id = response.data.service_id;
                        this.service_name = response.data.service_name;
                        
                        
                        this.$store.commit('set_service_id', this.service_id);
                        
                        
                        this.showCreateServiceForm = false;
                        this.loadServiceData();
                        this.get_available_workflows();

                    } else {
                       
                        this.showCreateServiceForm = true;
                        this.fetch_existing_service();
                        this.get_available_workflows();
                    }
                },
                error: (xhr) => {
                    console.error("Error checking workflow service:", xhr);
                    Swal.close();
                    
                    this.showCreateServiceForm = true;
                    this.fetch_existing_service();
                    this.get_available_workflows();
                }
            });
        },

        fetch_existing_service() {
            const token = localStorage.getItem('token');
            const base_url = API_BASE_URL;
            
          
            Swal.fire({
                text: 'Loading services...',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
            
            $.ajax({
                method: 'GET',
                url: `${base_url}/verify_api/workflow_managment_api/get_workflow_services/?workflow_id=${this.workflow_id}`,
                headers: {
                    Authorization: `Token ${token}`
                },
                success: (response) => {
                    Swal.close();
                    if (response.status === 'success') {
                        this.existingServices = response.data.services;
                    }
                },
                error: () => {
                    Swal.close();
                  
                    this.existingServices = [];
                }
            });
        },
        
        continue_with_service(service) {
            // Store the selected service ID
            this.$store.commit('set_service_id', service.service_id);
            this.service_id = service.service_id;
            this.service_name = service.service_name;
            

            this.loadServiceData();
            
            
            this.showCreateServiceForm = false;
        },
        
        async createService() {
            if (!this.serviceData.service_name.trim()) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Service Name Required',
                    text: 'Please enter a name for the service package',
                    timer: 3000,
                    timerProgressBar: true,
                    showConfirmButton: false
                });
                return;
            }

            this.isSubmitting = true;
            const token = localStorage.getItem('token');
            const base_url = API_BASE_URL;

            try {
                const checkResponse = await $.ajax({
                    method: 'GET',
                    url: `${base_url}/verify_api/service_management_api/check_service_name/`,
                    data: { service_name: this.serviceData.service_name },
                    headers: {
                        Authorization: `Token ${token}`
                    }
                });
                
                if (checkResponse.exists) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Name Already Exists',
                        text: 'A service with this name already exists. Please choose a different name.',
                        confirmButtonText: 'OK'
                    });
                    this.isSubmitting = false;
                    return;
                }
            } catch (error) {
            
                console.error("Error checking service name:", error);
            }

            Swal.fire({
                text: 'Creating service package...',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            $.ajax({
                method: 'POST',
                url: `${base_url}/verify_api/service_management_api/create_sub_workflow_service/`,
                contentType: 'application/json',
                data: JSON.stringify({
                    service_name: this.serviceData.service_name,
                    project_id: this.project_id,
                    workflow_id: this.workflow_id
                }), 
                headers: {
                    Authorization: `Token ${token}`
                },
                success: (response) => {
                    Swal.close();
                    
                    if (response.status === 'success') {
                        this.service_id = response.data.service_id;
                        this.service_name = this.serviceData.service_name;
                        this.$store.commit('set_service_id', response.data.service_id);
                        
                        
                        this.showCreateServiceForm = false;
                        
                      
                        this.loadServiceData();
                        
                        Swal.fire({
                            icon: 'success',
                            title: 'Service Created Successfully',
                            text: 'Now you can add workflow routers to this service',
                            timer: 2000,
                            timerProgressBar: true,
                            showConfirmButton: false
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Creation Failed',
                            text: response.message || 'Failed to create service',
                            confirmButtonText: 'OK'
                        });
                    }
                    this.isSubmitting = false;
                },
                error: (xhr) => {
                    Swal.close();
                    const error_msg = xhr.responseJSON?.message || 'Failed to create service';
                    Swal.fire({
                        icon: 'error',
                        title: 'Creation Failed',
                        text: error_msg,
                        confirmButtonText: 'OK'
                    });
                    this.isSubmitting = false;
                }
            });
        },
        
        skipCreation() {
            this.$router.push({ name: 'confirm_workflow' });
        },
      
        loadServiceData() {
           
            this.get_service_details();
            this.get_workflow_sub_workflows();
        },
        
        next() {
            if (this.workflows.length === 0) {
                Swal.fire({
                    title: 'No Sub-Workflows',
                    text: 'You are about to continue without adding any sub-workflows. Do you want to proceed?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, continue',
                    cancelButtonText: 'No, go back'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.$router.push({ name: 'confirm_workflow' });
                    }
                });
            } else {
                this.$router.push({ name: 'confirm_workflow' });
            }
        },

        get_service_details() {
            const token = localStorage.getItem('token');
            const base_url = API_BASE_URL;

            $.ajax({
                method: 'GET',
                url: `${base_url}/verify_api/service_management_api/get_service/${this.service_id}/`,
                headers: {
                    Authorization: `Token ${token}`
                },
                success: (response) => {
                    if (response.status === 'success') {
                        this.service_name = response.data.service_name;
                        this.workflow_name = `${response.data.service_name} Sub-Workflows`; 
                    }
                },
                error: () => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Failed to load service details',
                        timer: 3000,
                        timerProgressBar: true,
                        showConfirmButton: false
                    });
                }
            });
        },

        get_workflow_sub_workflows(){
            const token = localStorage.getItem('token');
            const base_url = API_BASE_URL;

            const get_customer_application_url = `${base_url}/verify_api/service_management_api/get_sub_workflows/`;
            $.ajax({
                method: 'GET',
                url: get_customer_application_url,
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${token}`
                },
                data: {
                    workflow_id: this.workflow_id
                },
                beforeSend: () => {
                    Swal.fire({
                        text: 'Loading ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    })
                },
                success: (response) => {
                    Swal.close();
                    
                    if (Array.isArray(response.data.workflow_name)) {
                        this.workflow_name = response.data.workflow_name[0] || 'Workflow';
                    } else {
                        this.workflow_name = response.data.workflow_name || 'Workflow';
                    }
                    
                    if (response.status === 'success') {
                        var sub_workflows = response.data.sub_workflows;
                        var sub_external_workflows = response.data.sub_external_workflows;
                        
                      
                        var combined_workflows = [];

                
                        if (Array.isArray(sub_workflows)) {
                            combined_workflows = combined_workflows.concat(
                                sub_workflows.map(workflow => ({
                                    id: workflow.id,
                                    workflow_id: workflow.workflow_id,
                                    workflow_name: workflow.workflow.workflow_name,
                                    service_name: workflow.service.service_name,
                                    router_name: workflow.router_name,
                                    external_link: '',
                                    date_created: workflow.created_at,
                                    is_active: workflow.is_active,
                                    sub_workflow_type: 'internal' 
                                }))
                            );
                        }

                  
                        if (Array.isArray(sub_external_workflows)) {
                            combined_workflows = combined_workflows.concat(
                                sub_external_workflows.map(workflow => ({
                                    id: workflow.id,
                                    workflow_id: '',
                                    workflow_name: '',
                                    service_name: workflow.service.service_name,
                                    router_name: workflow.router_name,
                                    external_url: workflow.external_link,
                                    date_created: workflow.created_at,
                                    is_active: workflow.is_active,
                                    sub_workflow_type: 'external'
                                }))
                            );
                        }

                        this.workflows = combined_workflows;
                    } else {
                        this.workflows = [];
                    }
                },
                error: (xhr) => {
                    Swal.close();
                    
                    const error_msg = xhr.responseJSON?.message || 'Failed to retrieve workflow information';
                    Swal.fire({
                        icon: 'error',
                        title: 'Retrieval Failed',
                        text: error_msg,
                        timer: 3000,
                        timerProgressBar: true,
                        showConfirmButton: false
                    });
                }
            });
        },
        
        get_available_workflows() {
            const token = localStorage.getItem('token');
            const base_url = API_BASE_URL;

            const get_workflows_url = `${base_url}/verify_api/workflow_management_api/get_project_workflows/${this.project_id}`;
            
            $.ajax({
                method: 'GET',
                url: get_workflows_url,
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${token}`
                },
                success: (response) => {
                    if (response.data && Array.isArray(response.data)) {
                        this.available_workflows = response.data.filter(workflow => 
                            workflow.workflow_id !== this.workflow_id
                        );
                    } else {
                        this.available_workflows = [];
                    }
                },
                error: () => {
                    this.available_workflows = [];
                }
            });
        },
        
        show_add_sub_workflow_modal() {
            
            this.new_sub_workflow = {
                service_name: '',
                sub_workflow_type: 'internal',
                external_url: '',
                workflow_id: ''
            };
           
            this.get_available_workflows()
            $('#add_sub_workflow_modal').modal('show');
        },
        
        prepend_https() {
            if (this.new_sub_workflow.external_url && !this.new_sub_workflow.external_url.startsWith('http')) {
                this.new_sub_workflow.external_url = 'https://' + this.new_sub_workflow.external_url;
            }
        },
        
        async add_sub_workflow() {
            const token = localStorage.getItem('token');
            const base_url = API_BASE_URL;
            const ENDPOINTS = {
                CHECK_STATUS: `${base_url}/verify_api/workflow_management_api/get_workflow_status/${this.workflow_id}`,
                UPDATE_STATUS: `${base_url}/verify_api/workflow_management_api/edit_workflow_api/`,
                EXTERNAL: `${base_url}/verify_api/service_management_api/create_service_external_api/`,
                INTERNAL: `${base_url}/verify_api/service_management_api/create_service_workflow_api/`
            };
        
            try {
          
                if (this.new_sub_workflow.sub_workflow_type === 'internal' && !this.new_sub_workflow.workflow_id) {
                    await Swal.fire({
                        icon: 'warning',
                        title: 'Missing Selection',
                        text: 'Please select a workflow to assign.',
                        timer: 3000,
                        timerProgressBar: true,
                        showConfirmButton: false
                    });
                    return;
                }
        
                if (this.new_sub_workflow.sub_workflow_type === 'external' && !this.new_sub_workflow.external_url) {
                    await Swal.fire({
                        icon: 'warning',
                        title: 'Missing URL',
                        text: 'Please provide an external URL for the service.',
                        timer: 3000,
                        timerProgressBar: true,
                        showConfirmButton: false
                    });
                    return;
                }
        
              
                const statusResponse = await $.ajax({
                    url: ENDPOINTS.CHECK_STATUS,
                    method: 'GET',
                    headers: {
                        Authorization: `Token ${token}`
                    }
                });
        
                
                if (statusResponse.status === 'approved') {
                    const result = await Swal.fire({
                        title: 'Warning',
                        text: 'This workflow is currently approved. Making changes will set it back to incomplete status. Do you want to continue?',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Yes, continue',
                        cancelButtonText: 'No, cancel',
                        cancelButtonColor: '#d33'
                    });
        
                    if (!result.isConfirmed) {
                        return;
                    }
        
                    
                    await $.ajax({
                        url: ENDPOINTS.UPDATE_STATUS,
                        method: 'POST',
                        contentType: 'application/json',
                        data: JSON.stringify({
                            workflow_id: this.workflow_id,
                            status: 'incomplete'
                        }),
                        headers: {
                            Authorization: `Token ${token}`
                        }
                    });
                }
        
            
                Swal.fire({
                    text: 'Adding workflow router...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });
        
                const request_data = {
                    service_id: this.service_id,
                    router_name: this.new_sub_workflow.service_name,
                    external_link: this.new_sub_workflow.external_url,
                    workflow_id: this.new_sub_workflow.workflow_id,
                    original_workflow_id: this.workflow_id,
                    project_id: this.project_id
                };

               
                const add_sub_workflow_url = this.new_sub_workflow.sub_workflow_type === 'external' 
                    ? ENDPOINTS.EXTERNAL 
                    : ENDPOINTS.INTERNAL;

                const response = await $.ajax({
                    method: 'POST',
                    url: add_sub_workflow_url,
                    contentType: 'application/json',
                    data: JSON.stringify(request_data),
                    headers: {
                        Authorization: `Token ${token}`
                    }
                });
        
            
                if (response.status !== 'success') {
                    throw new Error(response.message || 'Failed to add workflow router');
                }
        
                // Close modal and show success
                $('#add_sub_workflow_modal').modal('hide');
                
                // Clear the form
                this.new_sub_workflow = {
                    sub_workflow_type: 'external',
                    service_name: '',
                    external_url: '',
                    workflow_id: null
                };
        
                Swal.close();
                await Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: response.message || 'Workflow router added successfully',
                    timer: 2000,
                    timerProgressBar: true,
                    showConfirmButton: false
                });
        
                // Refresh sub workflows
                await this.get_workflow_sub_workflows();
        
            } catch (error) {
                Swal.close();
                
                const error_msg = error.responseJSON?.message || error.message || 'Failed to add workflow router';
                await Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error_msg,
                    confirmButtonText: 'OK'
                });
            }
        },
        
        previous_page() {
            if (this.current_page > 1) {
                this.current_page--;
            }
        },
        
        next_page() {
            if (this.current_page < this.total_pages) {
                this.current_page++;
            }
        },
        
        formatDate(date) {
            return format_date(date);
        },
        
        view_sub_workflow(sub_workflow) {
            this.selected_sub_workflow = sub_workflow;
            this.edited_sub_workflow = JSON.parse(JSON.stringify(sub_workflow));
        },
        
        close_sub_workflow_detail() {
            this.selected_sub_workflow = null;
            this.edited_sub_workflow = null;
        },
        
        save_sub_workflow_changes() {
            if (!this.edited_sub_workflow) {
                return;
            }

            const token = localStorage.getItem('token');
            const base_url = API_BASE_URL;

            let validation_passed = true;
            let validation_message = '';
            
            // Validation
            if (this.edited_sub_workflow.sub_workflow_type === 'internal' && !this.edited_sub_workflow.workflow_id) {
                validation_passed = false;
                validation_message = 'Please select a workflow to assign.';
            }

            if (this.edited_sub_workflow.sub_workflow_type === 'external' && !this.edited_sub_workflow.external_url) {
                validation_passed = false;
                validation_message = 'Please provide an external URL for the service.';
            }

            if (!validation_passed) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Validation Failed',
                    text: validation_message,
                    timer: 3000,
                    timerProgressBar: true,
                    showConfirmButton: false
                });
                return;
            }

            let update_sub_workflow_url;
            if(this.edited_sub_workflow.sub_workflow_type === 'external'){
                update_sub_workflow_url = `${base_url}/verify_api/service_management_api/update_service_external_api/`;
            }
            else {
                update_sub_workflow_url = `${base_url}/verify_api/service_management_api/update_service_workflow_api/`;
            }
            
            const request_data = {
                service_name: this.edited_sub_workflow.service_name,
                router_name: this.edited_sub_workflow.router_name,
                external_link: this.edited_sub_workflow.external_url,
                workflow_id: this.edited_sub_workflow.workflow_id,
                is_active: this.edited_sub_workflow.is_active
            };

            if(this.edited_sub_workflow.sub_workflow_type === 'external'){
                request_data.service_external_id =  this.edited_sub_workflow.id
            }
            else{
                request_data.service_workflow_id =  this.edited_sub_workflow.id
            }

            $.ajax({
                method: 'POST',
                url: update_sub_workflow_url,
                contentType: 'application/json',
                data: JSON.stringify(request_data),
                headers: {
                    Authorization: `Token ${token}`
                },
                beforeSend: () => {
                    Swal.fire({
                        text: 'Updating workflow router...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    });
                },
                success: () => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Workflow router updated successfully',
                        timer: 2000,
                        timerProgressBar: true,
                        showConfirmButton: false
                    });
                    this.get_workflow_sub_workflows();
                    this.close_sub_workflow_detail();
                },
                error: (xhr) => {
                    const error_msg = xhr.responseJSON?.message || 'Failed to update workflow router';
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: error_msg,
                        confirmButtonText: 'OK'
                    });
                }
            });
        }
    }
};
